export const US_CENTER_BOUNDS = [15, -148, 56, -55]
export const US_CENTER_LAT_LNG = {
  lat: 39.8097343,
  lng: -98.5556199,
}
export const GOOGLE_MAPS_BOUNDS_EXTENSION = 0.1
export const DEFAULT_ZOOM_LEVEL = 4
export const MIN_ZOOM_LEVEL = 3
export const MAX_ZOOM_LEVEL = 19
export const ICON_ANCHOR = [12, 34]
export const ICON_DIMENSIONS = [24, 34]
export const ICON_ANCHOR_HOVER = [16, 45]
export const ICON_DIMENSIONS_HOVER = [32, 45]
export const ICON_Z_INDEX_DEFAULT = 1
export const ICON_Z_INDEX_PRIORITY = 10
export const ASPECT_RATIO_TOLERANCE = 30
export const SPLIT_SCREEN_BREAKPOINT = 1200
export const MAP_ANCHOR_SECTIONS = 11
export const MAP_ANCHOR_COLUMN_WIDTH = -288
export const MOBILE_BREAKPOINT = 768
export const SMALL_MAP_WIDTH = 580
export const MAX_ALLOWED_PINS = 500
